/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/label-has-for */

import PropTypes from 'prop-types';
import classnames from 'classnames';

const Checkbox = ({
  input,
  label,
  labelName,
  labelClassName,
  type,
  isRequired,
  isSelected,
  meta,
}) => {
  const hasError = isRequired && !isSelected && meta.submitFailed;

  const boxClasses = {
    checkbox: true,
    relative: true,
    dtc: true,
    mt1: true,
    w2: true,
    h2: true,
  };

  const labelClasses = {
    'b--red': hasError,
    'bg-white': true,
    'absolute': true,
    'ba': hasError,
    'br1': true,
    'bw1': true,
    'pointer': true,
  };

  return (
    <div className="input pb2">
      <div className="field dt v-mid mb2">
        <div className={classnames(boxClasses)}>
          <input
            {...input}
            type={type}
            name={labelName}
            id={labelName}
            required={isRequired}
          />
          <label
            htmlFor={labelName}
            className={classnames(labelClasses, labelClassName)}
          />
        </div>
        <span className="dtc pl1">{label}</span>
      </div>
    </div>
  );
};

Checkbox.defaultProps = {
  isRequired: false,
  labelClassName: '',
};

Checkbox.propTypes = {
  isRequired: PropTypes.bool,
  isSelected: PropTypes.bool.isRequired,
  input: PropTypes.object.isRequired, // eslint-disable-line
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  labelName: PropTypes.string.isRequired,
  labelClassName: PropTypes.string,
  type: PropTypes.oneOf(['checkbox']).isRequired,
  meta: PropTypes.shape({
    submitFailed: PropTypes.bool.isRequired,
  }).isRequired,
};

export default Checkbox;
